import { StatusBar } from "expo-status-bar";
import React from "react";
import PropTypes from "prop-types";
import {
  StyleSheet,
  View,
  ScrollView,
  TouchableOpacity,
  ActivityIndicator,
  TouchableWithoutFeedback,
  Platform,
  TextInput,
  Dimensions,
} from "react-native";
import Text from "app/components/Text";
import Value from "app/components/Value";
import ValueBlur from "app/components/ValueBlur";
import ValueInput from "app/components/ValueInput";
import Generation from "app/components/Generation";
// import Canvas from 'app/components/Canvas'
import apiActions from "app/utils/apiActions";
import storageActions from "app/utils/storageActions";
import * as RootNavigation from "app/utils/RootNavigation.js";
import textHelpers from "app/utils/textHelpers";
import colorHelpers from "app/utils/colorHelpers";
import valueHelpers from "app/utils/valueHelpers";
import timeHelpers from "app/utils/timeHelpers";
import iconHelpers from "app/utils/iconHelpers";
import { styleSheet, colors, sizes, DARK } from "app/utils/styleSheet";
import {
  Ionicons,
  Octicons,
  FontAwesome,
  Feather,
  Entypo,
  MaterialCommunityIcons,
} from "@expo/vector-icons";

import Graph from "react-graph-vis";
import "vis-network/dist/dist/vis-network.css";

import Hoverable from "app/components/Hoverable";
const createLogger = (msg, value) => () => {
  // console.log(msg, value.name);
};

const WEB = Platform.OS == "web";
const REVERSE = false;
const CONSTELATE = true;

// export default class Overview({navigation}) {
export default class Map2 extends React.Component {
  static navigationOptions = ({
    navigation,
    navigationOptions,
    screenProps,
  }) => {
    return {
      headerShown: false,
    };
  };

  static propTypes = {
    screenProps: PropTypes.shape({
      // values: PropTypes.arrayOf(PropTypes.object),
    }),
  };

  constructor(props) {
    super(props);
    // let { user } = props.screenProps
    // props.navigation
    this.state = {
      values: [],
      topLevel: 0,
      fetching: false,
      query: "",
      hideComplete: false,
      fromBottom: true,
      showOnlyStarred: false,
      showHidden: 0,
      showDuplicates: false,
      showNotes: true,
      showSnoozed: 0,
      showDoneToday: 1,
      familyIds: [],
      selectedValue: null,
      selectedValueId: null,
      lines: [],
      quickActionsId: null,
      enableBlur: true,
      redrawKey: 0,
      scrollHeight: Dimensions.get("window").height,
      scrollHeight: null,
      hiddenIds: [],
    };

    let { navigation, route } = this.props;
    navigation.setOptions({
      headerRight: () => (
        <TouchableOpacity onPress={navigation.toggleDrawer}>
          <Ionicons
            name="ios-menu"
            size={32}
            color={colors.foreground}
            style={{ marginRight: 20 }}
          />
        </TouchableOpacity>
      ),
    });
  }

  async componentDidMount() {
    let hiddenIds = await storageActions.fetchItem("hiddenIds");
    let values = await storageActions.fetchItem("values");
    if (!!values) {
      values = valueHelpers.sortByTimeline(values);
      values = textHelpers.oldestFirst(values, "id");
      values = valueHelpers.applyColors(values);
      values = valueHelpers.applyBottomLevelParentId(values);
      let topLevel = valueHelpers.topLevel(values);
      this.setState({ values, hiddenIds, topLevel });
    }
    this._unsubscribe = this.props.navigation.addListener("focus", () => {
      this.fetch();
    });
    if (WEB && !!this.filterInput) this.filterInput.focus();
    this.revolver = setTimeout(this.revolve, 1000);
  }

  componentWillUnmount() {
    if (this._unsubscribe) this._unsubscribe();
    if (this.revolver) clearTimeout(this.revolver);
  }

  revolve = () => {
    this.setState({ revolution: this.state.revolution + 1 });
  };

  fetch = async () => {
    this.setState({ fetching: true });
    console.log("network view fetch...");
    let timestamp = Date.now();
    let values = await apiActions.request("values");
    let duration = (Date.now() - timestamp) / 1000;
    console.log(`fetch completed in ${duration.toFixed(2)} seconds`, values);
    if (!!values) {
      values = valueHelpers.sortByTimeline(values);
      values = textHelpers.oldestFirst(values, "id");
      values = valueHelpers.applyColors(values);
      values = valueHelpers.applyBottomLevelParentId(values);
      let topLevel = valueHelpers.topLevel(values);
      let hiddenIds = await storageActions.fetchItem("hiddenIds");
      this.setState({ values, hiddenIds, topLevel, fetching: false });
      storageActions.saveItem("values", values);
    } else console.warn("error", values);
  };

  render() {
    let { navigation } = this.props;
    let {
      values,
      fetching,
      query,
      hideComplete,
      showSnoozed,
      showOnlyStarred,
      showNotes,
      showDoneToday,
      fromBottom,
      familyIds,
      selectedValue,
      lines,
      quickActionsId,
      enableBlur,
      redrawKey,
      scrollHeight,
      showHidden,
      showDuplicates,
    } = this.state;

    let buttonColorOptions = [
      colors.trim,
      colors.active,
      colors.activeHighlight,
    ];

    return (
      <View style={styles.container} key={redrawKey}>
        <StatusBar style="auto" />
        <View style={[styles.row, styles.queryRow]}>
          {fetching ? (
            <ActivityIndicator />
          ) : (
            <TouchableOpacity
              onPress={this.fetch}
              style={[styles.icon, { marginRight: sizes.base }]}
            >
              <Ionicons
                name="md-refresh"
                size={sizes.itemHeight}
                color={colors.active}
              />
            </TouchableOpacity>
          )}
          <TextInput
            ref={(c) => (this.filterInput = c)}
            onKeyPress={this.handleKeyPress}
            style={styles.input}
            placeholderTextColor={colors.placeholder}
            value={query}
            placeholder={"filter"}
            onChangeText={(query) => this.setState({ query })}
          />
          <TouchableOpacity
            onPress={() => this.setState({ showDuplicates: !showDuplicates })}
            style={styles.icon}
          >
            <Text
              style={{ color: showDuplicates ? colors.active : colors.trim }}
            >
              Dups
            </Text>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => this.setState({ hideComplete: !hideComplete })}
            style={styles.icon}
          >
            <Feather
              name={"check-circle"}
              size={sizes.itemHeight}
              color={hideComplete ? colors.trim : colors.active}
            />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => this.setState({ fromBottom: !fromBottom })}
            style={{ marginLeft: sizes.base }}
          >
            <Entypo
              name="flow-tree"
              size={sizes.itemHeight}
              color={fromBottom ? colors.trim : colors.active}
              style={fromBottom ? null : { transform: [{ rotateZ: "180deg" }] }}
            />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() =>
              this.setState({
                showSnoozed: showSnoozed >= 2 ? 0 : showSnoozed + 1,
              })
            }
            style={{ marginLeft: sizes.base }}
          >
            <FontAwesome
              name="moon-o"
              size={sizes.itemHeight}
              color={buttonColorOptions[showSnoozed]}
            />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => this.setState({ redrawKey: redrawKey + 1 })}
            style={styles.icon}
          >
            {/*<MaterialCommunityIcons name="draw" size={sizes.itemHeight} color={colors.trim} />*/}
            <Text style={{ color: colors.trim }}>RE</Text>
          </TouchableOpacity>
          {/*<TouchableOpacity onPress={() => this.setState({showOnlyStarred: !showOnlyStarred})} style={styles.icon}>
            <Ionicons name={`ios-star${showOnlyStarred ? '' : '-outline'}`} size={sizes.itemHeight} color={showOnlyStarred ? colors.active : colors.trim} />
          </TouchableOpacity>*/}
          {/*<TouchableOpacity onPress={() => this.setState({showNotes: !showNotes})} style={styles.icon}>
            <Octicons name={`note`} size={sizes.itemHeight} color={showNotes ? colors.active : colors.trim} />
          </TouchableOpacity>*/}
          <TouchableOpacity
            onPress={() => this.setState({ enableBlur: !enableBlur })}
            style={styles.icon}
          >
            <FontAwesome
              name={"search"}
              size={sizes.itemHeight - 4}
              color={enableBlur ? colors.trim : colors.active}
            />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() =>
              this.setState({
                showDoneToday: showDoneToday >= 2 ? 0 : showDoneToday + 1,
              })
            }
            style={styles.icon}
          >
            <FontAwesome
              name={"calendar-check-o"}
              size={sizes.itemHeight - 4}
              color={buttonColorOptions[showDoneToday]}
            />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() =>
              this.setState({
                showHidden: showHidden >= 2 ? 0 : showHidden + 1,
              })
            }
            style={styles.icon}
          >
            <Ionicons
              name="md-eye-off"
              size={sizes.itemHeight - 4}
              color={buttonColorOptions[showHidden]}
            />
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => navigation.navigate("Create")}
            style={styles.icon}
          >
            <Ionicons
              name="ios-add-circle-outline"
              size={sizes.itemHeight}
              color={colors.foreground}
            />
          </TouchableOpacity>
        </View>

        {this.renderVisNetwork()}

        <View />
      </View>
    );
  }

  generateFamily = (value, values, parentNode = null) => {
    let { showDuplicates, topLevel, mapView } = this.state;
    let nodes = [];
    let edges = [];

    let node = this.generateNode(value, parentNode);
    nodes.push(node);

    let length = 10 + value.level * 80;
    edges.push({
      from: node.rootId,
      to: node.id,
      color: parentNode.valueColor,
      length,
    });

    let nextGen = values.filter((v) => value.parent_ids.includes(v.id));
    nextGen.map((nextVal) => {
      // if(!showDuplicates){
      //   let bottomParentLevel = nextVal.bottomParentLevel
      //   let bottomParentId = nextVal.bottomParentId
      //   if(bottomParentLevel <= value.level){
      //     if(!!bottomParentId && bottomParentId != value.id){
      //       return
      //     }
      //   }
      // }

      let family = this.generateFamily(nextVal, values, node);
      nodes = [...nodes, ...family.nodes];
      edges = [...edges, ...family.edges];
    });
    return { nodes, edges };
  };

  generateNode = (value, rootNode = null) => {
    let icon = value.icon || value.rootIcon || "";
    let color = value.color || value.inheritedColor;
    let background = colorHelpers.modifyHex(color, 0.6);
    let border = colorHelpers.averageColor([value.inheritedColor, value.color]);
    let id = value.id;
    let rootId = value.id;
    if (!!rootNode && !!rootNode.id) {
      id = `${rootNode.id}_${value.id}`;
      rootId = rootNode.id;
    }
    let x,
      y = undefined;

    let fixed = !!rootNode && rootNode.id == "root";
    // let mass = fixed ? 5 : 1
    let mass = 1 + value.level * 0.3;

    return {
      id,
      valueId: value.id,
      mass,
      rootId,
      title: valueHelpers.filterRichText(value.title || value.text),
      label: iconHelpers.unicode(icon),
      physics: !fixed,
      // fixed,
      // y: fixed ? undefined : 1000,
      // x: fixed ? undefined : 1000,
      font: {
        color,
        face: iconHelpers.fontFamily(icon),
      },
      color: {
        background,
        border,
        hover: {
          background,
          border,
        },
        highlight: {
          // background: border,
          border: background,
        },
      },
      valueColor: color,
      value: value.level + 1,
      x,
      y,
    };
  };

  renderVisNetwork = () => {
    let { values, topLevel } = this.state;
    values = this.applyFilters(values);
    values = values.filter((v) => !!v.id);

    let rootNode = {
      id: "root",
      label: " ",
      mass: 20,
      value: 1,
      x: 0,
      y: 0,
      fixed: { x: true, y: true },
      valueColor: colors.trim,
      color: {
        background: colors.empty,
        border: colors.trim,
        hover: {
          background: colors.empty,
          border: colors.trim,
        },
        highlight: {
          background: colors.empty,
          border: colors.trim,
        },
      },
    };
    let nodes = [rootNode];
    let edges = [];

    let startingLevel = values.filter((v) => !v.child_ids.length);
    startingLevel.map((value, i) => {
      let family = this.generateFamily(value, values, rootNode);
      nodes = [...nodes, ...family.nodes];
      edges = [...edges, ...family.edges];
    });

    // values.map(v => {
    //   let length = 50 + (v.level*70)
    //   if(!v.child_ids.length){
    //     let node = this.generateNode(v, rootNode)
    //     nodes.push(node)
    //     edges.push({from: node.rootId, to: node.id, color: node.valueColor, length})
    //   }
    //   else {
    //     let node = this.generateNode(v)
    //     nodes.push(node)
    //     v.child_ids.map(childId => {
    //       edges.push({from: childId, to: node.id, color: node.valueColor, length})
    //     })
    //   }
    // })

    const graph = { nodes, edges };

    const options = {
      layout: {
        hierarchical: false,
        // clusterThreshold: 50,
      },
      physics: {
        minVelocity: 0.1,
        stabilization: {
          enabled: true,
          iterations: 300,
          fit: true,
        },
        barnesHut: {
          gravitationalConstant: -70000, // -2000 - lower == greater repulsion
          centralGravity: 0.3, // 0.3 central pull
          springLength: 35, // 95 - length
          springConstant: 0.2, // 0.04 - sturdiness
          damping: 0.5, // 0.09 (0-1) - smoothing
          avoidOverlap: 0.5, // (0-1)
        },
      },
      edges: {
        color: "#000000",
        width: 2,
        hoverWidth: 3,
        dashes: true,
        smooth: {
          enabled: false,
          type: "continuous",
          // type: 'dynamic',
        },
        // arrows: false,
        // arrows: {
        //   to: {
        //     enabled: false,
        //   },
        //   middle: {
        //     enabled: true,
        //     // imageHeight: 32,
        //     // imageWidth: 32,
        //     scaleFactor: 1,
        //     // src: "https://visjs.org/images/visjs_logo.png",
        //     // type: "image"
        //     type: 'arrow',
        //   },
        //   from: {
        //     enabled: false,
        //   },
        // },
      },
      nodes: {
        shape: "circle",
        value: 1,
        scaling: {
          min: 10,
          max: 20,
          label: {
            enabled: true,
            min: 5,
            max: 10,
            maxVisible: 20,
            drawThreshold: 5,
          },
          // customScalingFunction: function (min,max,total,value) {
          //   return value
          // },
          customScalingFunction: function (min, max, total, value) {
            return value * 5;
          },
        },
        borderWidth: 4,
      },
      interaction: {
        hover: true,
        keyboard: {
          enabled: true,
        },
      },
      height: "1100px",
    };

    const events = {
      select: (event) => {
        console.log(event);
        let { nodes, edges } = event;
        if (!!nodes[0]) {
          let ids = nodes[0].split("_");
          let id = ids[ids.length - 1];
          // let id = nodes[0]
          this.selectById(id);
        } else {
          this.setState({ selectedValue: null });
        }
      },
    };
    return (
      <Graph
        graph={graph}
        options={options}
        events={events}
        getNetwork={(network) => {
          //  if you want access to vis.js network api you can set the state in a parent component using this property
          console.log(network);
          this.setState({ network });
        }}
      />
    );
  };

  selectById = (id) => {
    let { values, selectedValueId } = this.state;
    let value = values.find((v) => v.id == id);
    console.log(value);
    if (id == selectedValueId) {
      if (!!value) {
        RootNavigation.navigate("Value", { value, id: value.id });
      }
    } else {
      this.setState({ selectedValueId: id });
    }
  };

  applyFilters = (values, affectLeveling = true) => {
    let {
      hideComplete,
      showOnlyStarred,
      showNotes,
      showDoneToday,
      showHidden,
      showSnoozed,
      query,
      hiddenIds,
      showDuplicates,
    } = this.state;
    if (hideComplete) {
      // values = values.filter(v => textHelpers.doneSinceMilestone(v).length < 7 && !v.completed_at)
      values = values.filter((v) => !!!v.completed_at);
    }

    if (showSnoozed == 0)
      // none
      values = values.filter((v) => !valueHelpers.isSnoozed(v));
    else if (showSnoozed == 1)
      // either
      values = values;
    else if (showSnoozed == 2)
      // only
      values = values.filter((v) => valueHelpers.isSnoozed(v));

    if (showOnlyStarred) {
      // values = values.filter(v => v.starred)
    }
    if (!showNotes) {
      values = values.filter((v) => {
        if (v.child_ids.length == 0) {
          // notes cannot have children
          if (
            v.timeline.length == 2 &&
            v.milestones[0].indexOf("note from") == 0
          ) {
            // only entry is created as a note from parent value
            return false;
          } else if (
            v.timeline.length == 1 &&
            !timeHelpers.wasToday(v.timeline[0].timestamp)
          ) {
            // only entry is created at, and it wasn't today
            return false;
          }
        }
        return true;
      });
    }
    if (showDoneToday == 0 && !affectLeveling) {
      values = values.filter((v) => !textHelpers.wasDoneToday(v, true));
    }
    if (showDoneToday == 2) {
      let doneToday = values.filter((v) => textHelpers.wasDoneToday(v, true));
      let parentIds = doneToday.reduce(
        (ids, val) => [...ids, ...val.parent_ids],
        [],
      );
      while (parentIds.length) {
        let newDoneToday = values.filter(
          (v) => parentIds.indexOf(v.id) >= 0 && doneToday.indexOf(v) < 0,
        );
        parentIds = newDoneToday.reduce(
          (ids, val) => [...ids, ...val.parent_ids],
          [],
        );
        doneToday = [...doneToday, ...newDoneToday];
      }
      values = doneToday;
    }

    hiddenIds = hiddenIds || [];

    if (showHidden == 0 || showHidden == 2) {
      let shouldRemove = showHidden == 2;
      values = values.filter((v) => {
        if (hiddenIds.includes(v.id)) {
          return shouldRemove;
        } else if (v.parent_ids.length == 1) {
          if (hiddenIds.includes(v.parent_ids[0])) {
            // console.log(`hiding ${v.text} bc only parent is hidden: ${v.parent_ids[0]}`)
            hiddenIds.push(v.id);
            return shouldRemove;
          } else {
            return !shouldRemove;
          }
        }
        return !shouldRemove;
      });
    }
    // console.log('hiddenIds', hiddenIds)

    if (!affectLeveling) {
      // hide if level > 0 and no visible children
      // values = values.filter(v => !(v.level > 0 && !values.find(f => v.child_ids.includes(f.id) )))
    }

    values =
      !!query && query.length > 0
        ? values.filter((v) => {
            return (
              v.tile?.indexOf(query) >= 0 ||
              (!!v.revisions &&
                v.revisions.find((r) => r.title?.indexOf(query) >= 0))
            );
          })
        : values;

    return values;
  };

  handleKeyPress = (event) => {
    // console.log('keypress:', event.keyCode, event.keyValue)
    let triggerKey = false;
    // 13 == enter
    // 9 == tab
    if (event.keyCode == 9) {
      return;
      event.preventDefault();
      console.log("tab");
      if (this.state.shiftIsDown) {
        console.log("unindent!");
        // this.handleUnindentItem(item)
      } else {
        // this.handleIndentItem(item)
      }
    } else if (event.keyCode == 13) {
      event.preventDefault();
      console.log("enter");
      // this.handleAppendItem(item)
    } else if (event.keyCode == 8) {
      console.log("backspace");
      // if(item.text == ''){
      // this.handleDeleteItem(item)
      // }
    } else if (event.keyCode == 16) {
      console.log("shift down");
      this.setState({ shiftIsDown: true });
      triggerKey = true;
    } else if (event.keyCode == 27) {
      console.log("escape");
      this.setState({ query: "" });
    }
    // 38 // up
    // 39 // right
    // 40 // down
    // 37 // left
    if (!triggerKey) {
      this.setState({ shiftIsDown: false });
    }
  };
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: "column",
    justifyContent: "space-around",
    backgroundColor: DARK ? undefined : colors.foreground,
  },
  row: {
    flexGrow: 1,
    borderColor: colors.trim,
    // borderBottomWidth: 1,
    alignSelf: "stretch",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: sizes.large,
  },
  queryRow: {
    flexGrow: 0,
    height: 50,
    padding: sizes.base,
    justifyContent: "flex-start",
  },
  input: {
    ...styleSheet.input,
    alignSelf: "stretch",
    flex: 1,
  },
  icon: {
    marginLeft: sizes.base,
    minWidth: sizes.base,
    minHeight: sizes.base,
    // borderWidth: 1, borderColor: 'white',
  },
});
